module.exports = __webpack_public_path__ + "img/pn.c21d4f35.svg";